export const manageusersData = [
  {
		id: "U461893",
		name: "Janet",
		class: "Year 3",
		section: "Jupiter",
		dateOfJoined: "25 Mar 2024",
		status: "Active",
		key:1
	},
	{
		id: "U461892",
		name: "Joann",
		class: "Year 4",
		section: "Mars",
		dateOfJoined: "18 Mar 2024",
		status: "Active",
		key:2
	},
	{
		id: "U461891",
		name: "Kathleen",
		class: "Year 2",
		section: "Jupiter",
		dateOfJoined: "14 Mar 2024",
		status: "Active",
		key:3
	},
	{
		id: "U461890",
		name: "Gifford",
		class: "Year 1",
		section: "Mars",
		dateOfJoined: "27 Feb 2024",
		status: "Active",
		key:4
	},
	{
		id: "U461889",
		name: "Lisa",
		class: "Year 2",
		section: "Mars",
		dateOfJoined: "13 Feb 2024",
		status: "Active",
		key:5
	},
	{
		id: "U461888",
		name: "Ralph",
		class: "Year 3",
		section: "Mars",
		dateOfJoined: "11 Feb 2024",
		status: "Active",
		key:6
	},
	{
		id: "U461887",
		name: "Julie",
		class: "Year 5",
		section: "Jupiter",
		dateOfJoined: "24 Jan 2024",
		status: "Active",
		key:7
	},
	{
		id: "U461886",
		name: "Ryan",
		class: "Year 4",
		section: "Jupiter",
		dateOfJoined: "19 Jan 2024",
		status: "Active",
		key:8
	},
	{
		id: "U461885",
		name: "Susan",
		class: "Year 8",
		section: "Mars",
		dateOfJoined: "08 Jan 2024",
		status: "Active",
		key:9
	},
	{
		id: "U461884",
		name: "Richard",
		class: "Year 7",
		section: "Mars",
		dateOfJoined: "22 Dec 2024",
		status: "Active",
		key:10
	}
];
